import { Drawer } from 'ui/drawer';
import { ExpandModes, useExpansionContext } from 'utils/contexts/expansion';

import { Footer } from './Footer';
import { CatalogPreviewTable } from './CatalogPreviewTable';
import { QueryBuilder } from './QueryBuilder';
import { Title } from './Title';
import { Selector } from './Selector';
import { Divider } from './Divider';
import { useCatalogPreviewContext } from './contexts/CatalogPreviewContext';
import { useUpdateCatalogDrawer } from './hooks/useUpdateCatalogDrawer';
import { useResetCatalogDrawer } from './hooks/useResetCatalogDrawer';

export const CatalogQueryDrawerContent = () => {
  const { closePreview } = useCatalogPreviewContext();
  const { collapse, mode } = useExpansionContext();
  useUpdateCatalogDrawer();
  useResetCatalogDrawer();

  const closePreviewAndCollapseDrawer = () => {
    closePreview();
    collapse();
  };

  return (
    <Drawer
      title={<Title />}
      footer={<Footer />}
      onClose={closePreviewAndCollapseDrawer}
      isExpanded={mode === ExpandModes.expand}
    >
      <Selector />
      <Divider />
      <QueryBuilder />
      <CatalogPreviewTable />
    </Drawer>
  );
};
